<template>
  <div id="app">
    <div id="map" class="map"></div>

    <img width="300px" src="./assets/ad.png" />
    <HelloWorld msg="Welcome to Your Vue.js App" />
  </div>
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";
import Vue from "vue";
import firebase from "firebase";
require("firebase/firestore");

var firebaseConfig = {
  apiKey: "AIzaSyByyQnDCCwCFIVzKqQWLvHClc-Zr0rv0HU",
  authDomain: "toomanycamps.firebaseapp.com",
  databaseURL: "https://toomanycamps.firebaseio.com",
  projectId: "toomanycamps",
  storageBucket: "toomanycamps.appspot.com",
  messagingSenderId: "730808672861",
  appId: "1:730808672861:web:2ea5e719d536d8efb163b4"
};
// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);

const fs = firebase.firestore(app);
Vue.prototype.$fs = fs;

export default {
  name: "App",
  components: {
    HelloWorld
  }
};
</script>

<style>
.map {
  float: right;
  height: 180px;
  width: 300px;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}
</style>
